<template>
  <artmisads-modal
    v-model:open="open"
    @ok="onOk"
    @cancel="onModalCancel"
    style="width: 600px"
    :okText="$t('seller.common.confirm')"
    :cancelText="$t('seller.common.cancel')"
  >
     <template #title>
      <Icon name="a-warring-tianchong3" class="icon-style" />
      <span style="padding-left: 10px">{{ $t('seller.common.cancelScheduledTask') }}</span>
    </template>
    <div class="content">
      <span>{{ $t('seller.common.cancelScheduledTaskConfirm', { n: len }) }}</span>
    </div>

  </artmisads-modal>
</template>
<script setup >
import { ref,defineEmits } from 'vue'
import i18n from '~/i18n'
import Icon from '@/components/Icon.vue'
import { productsApi, brandApi } from '@/server/index'
import { message } from 'ant-design-vue'
const cancelList=ref([])
const open = ref(false)
const len=ref(0)

const emit = defineEmits(['ok'])
const onOk = () => {
  open.value = false
  const operationIdList= cancelList.value

  brandApi.cancelBatchTask({
    operationIdList,
  }).then(res=>{

    if(res.success){
      message.success(i18n.global.t('seller.msg.cancelTasksDone', { n: cancelList?.value?.length }), 1)
      emit('ok')
    }else{
      message.error(res.message, 1)
    }
  })
  // console.log(operationIdList,'operationIdList')

}
const onModalCancel = () => {
  open.value = false
}
const init = (list,length) => {
  open.value = true
  len.value=length
  cancelList.value=list
}
defineExpose({
  init,
})
</script>
<style lang="less" scoped>
.icon-style {
  fill: rgba(245, 155, 0, 1);
}
.content{
  font-family: Sora;
font-weight: 400;
font-style: Regular;
font-size: 14px;
leading-trim: NONE;
line-height: 30px;
letter-spacing: 0.3px;
color: rgba(15, 6, 41, 1);
}
</style>
